import React, {
    useEffect,
    useRef,
    useState,
} from 'react'
import {HistoryState} from '../../navigation/types'
import Navigator from './Navigator'
import {navigation} from '../../navigation'
import {useAppSelector} from '../../hooks'

const Navigation: React.FunctionComponent = () => {
    const hasSession = useAppSelector(({ninchat}) => !!ninchat.session_id)
    const navigationState = useAppSelector(({navigation: _navigationState}) => _navigationState)
    const isModalOpen = useAppSelector(({ui}) => ui.isModalOpen)

    const popstate = useRef<HistoryState>({
        position: -1,
        route: null,
    })

    const [ready, setReady] = useState(false)

    const onPopState = (event: PopStateEvent) => {
        if (!isModalOpen) {
            popstate.current = event.state
        }
    }

    const onHashChange = (event: HashChangeEvent) => {
        if (!isModalOpen) {
            navigation.hash(event, popstate.current)
            return
        }
        event.preventDefault()
        navigation.freeze()
    }

    useEffect(() => {
        navigation.init()
        setReady(true)
    }, [])

    useEffect(() => {
        addEventListener('popstate', onPopState)
        addEventListener('hashchange', onHashChange)

        return () => {
            removeEventListener('hashchange', onHashChange)
            removeEventListener('popstate', onPopState)
        }
    }, [isModalOpen])

    if (!ready) {
        return null
    }

    return (
        <Navigator
            hasSession={hasSession}
            navigationState={navigationState}
        />
    )
}

export default Navigation
